import comment from 'iztech-design-system-neo/dist/system/i18n/en/comment'

export default {
  ...comment,
  MSG_COMMENT_SUCCESS: 'The system has received your comment!',
	MSG_COMMENT_SUCCESS_AND_WAIT_APPROVAL: 'The system has received your comment. Please wait for checking from admin!',
	MSG_COMMENT_FAIL: 'The system has not received your comment. Please try again later.',
	MSG_COMMENT_LOADING: 'The system has received your comment. Please wait a little bit!',
}